import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const userAuth = createAsyncThunk(
    'api/postRequest',
    async ({ api, body = {}, headers = {} }, thunkAPI) => {
        try {
            const response = await fetch(api, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...headers
                },
                body: JSON.stringify(body)
            });

            const data = await response.json();

            if (!response.ok) {
                return thunkAPI.rejectWithValue(data);
            }

            return data;
        } catch (error) {
            return thunkAPI.rejectWithValue({ message: error.message });
        }
    }
);



export const authSlice = createSlice({
  name: 'user',
  initialState: {
    user: {},
    loading: false,
    error: '',
    activeDb: 'prod' // default DB
  },
  reducers: {
    changeDatabase: (state, action) => {
      state.activeDb = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userAuth.pending, (state) => {
        state.loading = true;
      })
      .addCase(userAuth.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(userAuth.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { changeDatabase } = authSlice.actions;

export default authSlice.reducer

